import { Listing } from '@reverbdotcom/commons/src/rql';
import { IBulkSelectState } from './BulkSelectContext';

export enum ActionType {
  ADD_SELECTABLE_LISTINGS = 'addSelectableListings',
  REMOVE_SELECTABLE_LISTING = 'removeSelectableListing',
  SELECT_ALL_LISTINGS = 'selectAllListings',
  DESELECT_ALL_LISTINGS = 'deselectAllListings',
  ADD_SELECTED_LISTING = 'addSelectedListing',
  REMOVE_SELECTED_LISTING = 'removeSelectedListing',
}

interface IPayload {
  listing?: Listing;
  selectableListings?: Listing[];
}

interface IAction {
  type: ActionType;
  payload?: IPayload;
}


export default function bulkSelectReducer(state: IBulkSelectState, action: IAction): IBulkSelectState {
  switch (action.type) {
    case ActionType.ADD_SELECTABLE_LISTINGS: {
      return {
        ...state,
        ...{ selectableListings: action.payload.selectableListings },
      };
    }

    case ActionType.REMOVE_SELECTABLE_LISTING: {
      const updatedSelectableListings = state.selectableListings.filter(selectableListing => selectableListing.id != action.payload.listing.id);

      return {
        ...state,
        ...{ selectableListings: updatedSelectableListings },
      };
    }

    case ActionType.SELECT_ALL_LISTINGS: {
      return {
        ...state,
        ...{ selectedListings: state.selectableListings },
      };
    }

    case ActionType.DESELECT_ALL_LISTINGS: {
      return {
        ...state,
        ...{ selectedListings: [] },
      };
    }

    case ActionType.ADD_SELECTED_LISTING: {
      const updatedListings = [...state.selectedListings, ...[action.payload.listing]];

      return {
        ...state,
        ...{ selectedListings: updatedListings },
      };
    }

    case ActionType.REMOVE_SELECTED_LISTING: {
      const updatedListings = state.selectedListings.filter(listing => action.payload.listing.id != listing.id);

      return {
        ...state,
        ...{ selectedListings: updatedListings },
      };
    }

    default: {
      return { ...state };
    }
  }
}
